import type { ClientLogo, LogoInkMode } from '../types/logos';

/** Target visual area per logo in px² at scale 1. Equal area reads as equal weight. */
const BASE_AREA = 3600;
const MIN_HEIGHT = 16;
const MAX_HEIGHT = 44;
const MAX_WIDTH = 184;

export function getLogoBox(logo: ClientLogo) {
  const cw = logo.crop.x2 - logo.crop.x1;
  const ch = logo.crop.y2 - logo.crop.y1;
  const aspect = (cw * logo.width) / (ch * logo.height);

  // Wide wordmarks get less height, compact marks more.
  let height = Math.sqrt(BASE_AREA / aspect) * (logo.weight ?? 1);
  height = Math.min(MAX_HEIGHT, Math.max(MIN_HEIGHT, height));
  let width = height * aspect;
  if (width > MAX_WIDTH) {
    width = MAX_WIDTH;
    height = width / aspect;
  }

  return {
    width: Math.round(width * 10) / 10,
    height: Math.round(height * 10) / 10,
    image: {
      width: `${100 / cw}%`,
      height: `${100 / ch}%`,
      left: `${(-logo.crop.x1 / cw) * 100}%`,
      top: `${(-logo.crop.y1 / ch) * 100}%`,
    },
  };
}

/** feColorMatrix values that write the logo's "ink" into the alpha channel. */
export function inkMatrix(mode: LogoInkMode) {
  const rgb = '0 0 0 0 0  0 0 0 0 0  0 0 0 0 0';
  if (mode === 'dark') return `${rgb}  -0.2126 -0.7152 -0.0722 0 1`;
  if (mode === 'light') return `${rgb}  0.2126 0.7152 0.0722 0 0`;
  return `${rgb}  0 0 0 1 0`;
}

export const logoFilterId = (id: string) => `logo-filter-${id}`;
